<template>
  <SoContainer>
    <h4 class="mb-4">Property Meterpoints</h4>
    <SoRadioCards v-model="tariffQuoter.selectedFuels" multiple>
      <SoRow>
        <SoCol v-if="tariffQuoter?.mpans.length" :default-width="6">
          <MPXNEstimationRadioCard
            is-electricity
            data-testid="tq-mpan-selector"
          >
            <template #title>
              <h5>
                MPAN -
                <template v-if="tariffQuoter?.mpans[0].isExport"
                  >EXPORT -
                </template>
                {{ tariffQuoter?.mpans[0].identifier }}
              </h5>
            </template>
            <template
              v-for="(mpan, index) in tariffQuoter?.mpans"
              :key="mpan.identifier"
            >
              <template v-if="index !== 0">
                <SoDivider class="mt-4" />
                <div class="d-flex align-center my-4">
                  <SoAvatar type="electric" class="mr-2" />
                  <h5 data-testid="meter-id">
                    MPAN - <template v-if="mpan.isExport">EXPORT - </template>
                    {{ mpan.identifier }}
                  </h5>
                </div>
              </template>
              <div class="meterpoints__layout-grid mb-4">
                <div>Meter Serial Number</div>
                <div>{{ mpan.meterSerialNumber }}</div>
                <div>Profile Class</div>
                <div>{{ mpan.profileClassId }}</div>
                <div>Time Switch Code</div>
                <div>{{ mpan.meterTimeSwitchCode }}</div>
                <div>SSC</div>
                <div>{{ mpan.standardSettlementConfigurationId }}</div>
                <div>Measurement Class</div>
                <div>{{ mpan.measurementClass }}</div>
                <div>Is Engerised?</div>
                <div>{{ mpan.isEnergised }}</div>
              </div>
            </template>
          </MPXNEstimationRadioCard>
        </SoCol>
        <SoCol v-if="tariffQuoter?.mprns.length" :default-width="6">
          <MPXNEstimationRadioCard data-testid="tq-mprn-selector">
            <template #title>
              <h5>MPRN - {{ tariffQuoter?.mprns[0].identifier }}</h5>
            </template>
            <template
              v-for="(mprn, index) in tariffQuoter?.mprns"
              :key="mprn.identifier"
            >
              <template v-if="index !== 0">
                <SoDivider class="mt-4" />
                <div class="d-flex align-center my-4">
                  <SoAvatar type="gas" class="mr-2" />
                  <h5 data-testid="meter-id">MPRN - {{ mprn.identifier }}</h5>
                </div>
              </template>

              <div class="meterpoints__layout-grid mb-4">
                <div>Meter Serial Number</div>
                <div>{{ mprn.meterSerialNumber }}</div>
                <div>Designation</div>
                <div>{{ mprn.designation }}</div>
                <div>Is Prepay?</div>
                <div>{{ mprn.isPrepay }}</div>
              </div>
            </template>
          </MPXNEstimationRadioCard>
        </SoCol>
      </SoRow>
    </SoRadioCards>
  </SoContainer>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useTariffQuoter } from "@/stores/tariffQuoter"
  import MPXNEstimationRadioCard from "../components/MPXNEstimationRadioCard.vue"
  import SoContainer from "@/components/SoContainer.vue"
  import SoAvatar from "@/components/SoAvatar.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import SoRadioCards from "@/components/SoRadioCards.vue"
  import SoDivider from "@/components/SoDivider.vue"

  export default defineComponent({
    components: {
      MPXNEstimationRadioCard,
      SoContainer,
      SoAvatar,
      SoRow,
      SoCol,
      SoRadioCards,
      SoDivider,
    },
    data() {
      return {
        tariffQuoter: useTariffQuoter(),
      }
    },
  })
</script>

<style scoped>
  .meterpoints__layout-grid {
    display: grid;
    grid-template-columns: 8fr 12fr;
    gap: 8px;
  }
</style>
